class VideoModal {
  constructor() {
    this.modal = null;
    this.iframe = null;
    this.init();
  }

  init() {
    // Create modal HTML if it doesn't exist
    if (!document.getElementById('video-modal')) {
      this.createModal();
    } else {
      this.modal = document.getElementById('video-modal');
      this.iframe = document.getElementById('youtube-video');
    }

    // Add event listeners
    this.attachEventListeners();
  }

  createModal() {
    const modalHTML = `
      <div id="video-modal" class="fixed inset-0 z-50 overflow-hidden hidden" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div class="flex items-center justify-center min-h-screen p-4">
          <!-- Background overlay -->
          <div class="fixed inset-0 bg-gray-900 bg-opacity-90 backdrop-blur-sm transition-opacity video-modal-overlay"></div>

          <!-- Modal content -->
          <div class="relative bg-black rounded-lg overflow-hidden shadow-2xl transform transition-all w-full max-w-6xl">
            <!-- Close button -->
            <button class="absolute top-4 right-4 z-10 text-white hover:text-gray-300 transition-colors video-modal-close">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <!-- Video container with responsive aspect ratio -->
            <div class="relative pt-[56.25%]">
              <iframe
                id="youtube-video"
                class="absolute inset-0 w-full h-full"
                src=""
                title="Video"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen>
              </iframe>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);
    this.modal = document.getElementById('video-modal');
    this.iframe = document.getElementById('youtube-video');
  }

  attachEventListeners() {
    // Close button click
    const closeButton = this.modal.querySelector('.video-modal-close');
    if (closeButton) {
      closeButton.addEventListener('click', () => this.close());
    }

    // Overlay click
    const overlay = this.modal.querySelector('.video-modal-overlay');
    if (overlay) {
      overlay.addEventListener('click', () => this.close());
    }

    // Escape key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.modal.classList.contains('hidden')) {
        this.close();
      }
    });
  }

  open(videoUrl) {
    // Convert YouTube URL to embed format if needed
    const embedUrl = this.getEmbedUrl(videoUrl);

    // Set the video URL with autoplay
    this.iframe.src = `${embedUrl}?autoplay=1&rel=0`;

    // Show the modal
    this.modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';

    // Track analytics events
    this.trackAnalytics(videoUrl);
  }

  trackAnalytics(videoUrl) {
    // Track with Google Analytics if available
    if (typeof gtag !== 'undefined') {
      gtag('event', 'watch_demo', {
        'event_category': 'video',
        'event_label': videoUrl
      });
    }

    // Track with Plausible if available
    if (typeof plausible !== 'undefined') {
      plausible('Watch Demo', {
        props: {
          video_url: videoUrl
        }
      });
    }
  }

  close() {
    // Hide the modal
    this.modal.classList.add('hidden');
    document.body.style.overflow = '';

    // Stop the video by clearing the src
    this.iframe.src = '';
  }

  getEmbedUrl(url) {
    // Handle different YouTube URL formats
    let videoId = '';

    if (url.includes('youtube.com/watch')) {
      // Format: https://www.youtube.com/watch?v=VIDEO_ID
      const urlParams = new URLSearchParams(new URL(url).search);
      videoId = urlParams.get('v');
    } else if (url.includes('youtu.be/')) {
      // Format: https://youtu.be/VIDEO_ID
      videoId = url.split('youtu.be/')[1].split('?')[0];
    } else if (url.includes('youtube.com/embed/')) {
      // Already in embed format
      return url.split('?')[0];
    } else {
      // Assume it's just the video ID
      videoId = url;
    }

    return `https://www.youtube.com/embed/${videoId}`;
  }
}

// Initialize video modal when DOM is ready
let videoModal;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    videoModal = new VideoModal();
  });
} else {
  videoModal = new VideoModal();
}

// Global functions for backward compatibility and easy usage
window.openVideoModal = function(videoUrl) {
  if (!videoModal) {
    videoModal = new VideoModal();
  }
  videoModal.open(videoUrl);
};

window.closeVideoModal = function() {
  if (videoModal) {
    videoModal.close();
  }
};